import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import { formatDateTime, plainExcerpt } from '../utils/format';
import { ticketUrl } from '../utils/ticketUrl';
const T = (key, params) => app.translator.trans('cengizkemec-support.forum.' + key, params);
const OPEN_STATUSES = ['new', 'answered', 'pending'];
export default class TicketList extends Component {
  view(vnode) {
    const filter = vnode.attrs.filter || 'all';
    let tickets = app.store.all('tickets');
    if (filter === 'open') {
      tickets = tickets.filter(t => OPEN_STATUSES.indexOf(t.status()) >= 0);
    } else if (filter === 'closed') {
      tickets = tickets.filter(t => OPEN_STATUSES.indexOf(t.status()) < 0);
    }
    if (!tickets.length) {
      return m("div", {
        className: "SupportEmpty"
      }, m("div", {
        className: "SupportEmpty-icon"
      }, m("i", {
        className: "icon far fa-life-ring"
      })), m("div", {
        className: "SupportEmpty-title"
      }, T('empty_title')), m("div", {
        className: "SupportEmpty-text"
      }, T('empty_text')));
    }
    return m("ul", {
      className: "SupportList"
    }, tickets.map(ticket => this.card(ticket)));
  }
  card(ticket) {
    const status = ticket.status();
    const priority = ticket.priority();
    const category = ticket.category();
    const replies = ticket.replies && ticket.replies() || [];
    return m("li", {
      key: ticket.id()
    }, m(Link, {
      className: 'SupportCard SupportCard--' + status,
      href: ticketUrl(ticket)
    }, m("div", {
      className: "SupportCard-top"
    }, m("h3", {
      className: "SupportCard-title"
    }, ticket.subject()), m("div", {
      className: "SupportCard-badges"
    }, m("span", {
      className: 'SupportPriority SupportPriority--' + priority
    }, T('priority.' + priority)), m("span", {
      className: 'SupportBadge SupportBadge--' + status
    }, T('status.' + status)))), ticket.message() && m("p", {
      className: "SupportCard-excerpt"
    }, plainExcerpt(ticket.messageHtml && ticket.messageHtml(), ticket.message())), m("div", {
      className: "SupportCard-meta"
    }, category && m("span", {
      className: "SupportChip"
    }, m("i", {
      className: "icon fas fa-folder"
    }), " ", category.name()), category && category.department && category.department() && m("span", {
      className: "SupportChip"
    }, m("i", {
      className: "icon fas fa-building"
    }), " ", category.department().name()), m("span", {
      className: "SupportChip"
    }, m("i", {
      className: "icon far fa-clock"
    }), " ", formatDateTime(ticket.createdAt())), replies.length > 0 && m("span", {
      className: "SupportChip"
    }, m("i", {
      className: "icon far fa-comment"
    }), " ", replies.length), ticket.assignee() && m("span", {
      className: "SupportChip"
    }, m("i", {
      className: "icon fas fa-user-check"
    }), " ", ticket.assignee().displayName()))));
  }
}
flarum.reg.add('cengizkemec-support-tickets', 'forum/components/TicketList', TicketList);